import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-buy-permits-header',
    templateUrl: './buy-permits-header.component.html',
    styleUrls: ['./buy-permits-header.component.scss'],
    standalone: false
})
export class BuyPermitsHeaderComponent implements OnInit {
  @Input() forestName: string;
  @Input() productName: string;
  @Input() permitStepLabels: string[];
  @Input() currentStepIndex: number;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {
  }

  ngOnInit() {
  }

}

